// The four tabs, their labels, and the mono line that sits under the tab bar.

import type { LibraryTab, ShelfTotals } from "../../lib/library-types";
import { inWords } from "../../lib/numberWords";

export const LIBRARY_TABS: LibraryTab[] = ["reading", "store", "browse", "collections"];

export const TAB_LABEL: Record<LibraryTab, string> = {
  reading: "Reading Now",
  store: "Book Store",
  browse: "Browse all",
  collections: "Collections",
};

export const DEFAULT_TAB: LibraryTab = "reading";

export function isLibraryTab(value: string | null): value is LibraryTab {
  return value !== null && (LIBRARY_TABS as string[]).includes(value);
}

/** Reads `?tab=`, falling back to Reading Now for anything unrecognised. */
export function tabFromParam(value: string | null): LibraryTab {
  return isLibraryTab(value) ? value : DEFAULT_TAB;
}

/**
 * The line under the tab bar. Derived from live totals rather than hardcoded —
 * the moment anyone publishes, a literal "164 books · 19 kinds" is wrong.
 */
export function tabMeta(tab: LibraryTab, totals: ShelfTotals): string {
  switch (tab) {
    case "store":
      return `${totals.books} books · ${totals.kinds} kinds · every one free`;
    case "browse":
      return "Complete texts · free · no account";
    case "collections":
      return `${inWords(totals.collections)} collections · chosen by the house`;
    case "reading":
    default:
      return "Free · no account · read in the browser";
  }
}
